import { Directive, ElementRef, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appRolloverDirective]',
    inputs: ['rolloverCss']
})
export class RolloverCssDirective implements OnInit, OnDestroy {
    private element: ElementRef;
    private renderer: Renderer2;
    private zone: NgZone;
    private listeners: Function[] | null;
    rolloverCss: string = 'mat-elevation-z8';
  
    constructor(private e: ElementRef,
        private r: Renderer2,
        private z: NgZone) {
        this.element = e;
        this.renderer = r;
        this.zone = z;
    }
  
  
    ngOnInit() {
        this.zone.runOutsideAngular(() => {
            this.listeners = [
                this.renderer.listen(this.element.nativeElement, "mouseenter", this.onMouseEnter),
                this.renderer.listen(this.element.nativeElement, "mouseleave", this.onMouseLeave)
            ];
        });
    }
  
    ngOnDestroy() {
        if (this.listeners) {
            for (var listener of this.listeners) {
              listener();
            }
        }
    }
  
    private onMouseEnter = (event: MouseEvent): void => {
        this.zone.runGuarded(() => {
            this.renderer.addClass(this.element.nativeElement, this.rolloverCss);
        });    
    }
  
    private onMouseLeave = (event: MouseEvent): void => {
        this.zone.runGuarded(() => {
            this.renderer.removeClass(this.element.nativeElement, this.rolloverCss);
        });
    }
}
